import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  
  const navItems = [
    { name: 'Ana Səhifə', path: '/' },
    { name: 'Haqqında', path: '/about' },
    { name: 'İmkanlar', path: '/amenities' },
    { name: 'Qiymətlər', path: '/pricing' },
    { name: 'Qalereya', path: '/gallery' },
    { name: 'Yer', path: '/location' },
    { name: 'Əlaqə', path: '/contact' }
  ];
  
  const isActive = (path) => location.pathname === path;
  
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-green-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-gradient-to-br from-green-600 to-blue-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xl">QN</span>
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">Quba Nügədi Villa</h1>
              <p className="text-xs text-green-700">Təbiətin qoynunda istirahət</p>
            </div>
          </Link>
          
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                  isActive(item.path)
                    ? 'bg-green-50 text-green-700'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-green-600'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>
          
          {/* Contact Button */}
          <div className="hidden lg:flex items-center space-x-3">
            <a href="tel:+994999949944">
              <Button className="bg-green-600 hover:bg-green-700 text-white">
                <Phone className="w-4 h-4 mr-2" />
                Zəng Et
              </Button>
            </a>
          </div>
          
          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 rounded-lg text-gray-600 hover:bg-gray-100"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
        
        {/* Mobile Navigation */}
        {isOpen && (
          <nav className="lg:hidden pb-4 space-y-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-all ${
                  isActive(item.path)
                    ? 'bg-green-50 text-green-700'
                    : 'text-gray-600 hover:bg-gray-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <a href="tel:+994999949944" onClick={() => setIsOpen(false)}>
              <Button className="w-full bg-green-600 hover:bg-green-700 text-white mt-2">
                <Phone className="w-4 h-4 mr-2" />
                Zəng Et
              </Button>
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};